/* Init */

/*
    Set this as the master scroll event to keep a lot of code from firing on scroll.
    When you want to execute based on scroll behavior, use:
    setInterval(function() {
        if(scrolling) {
            scrolling = false;
            CODE();
        }
    }, 250);
*/
let scrolling = false;
window.addEventListener("scroll", function () {
    scrolling = true;
});

/********************************************************
 ** HELPER FUNCTIONS
 ********************************************************/
/*
    Any functions that have a jQuery equivalent I have tried to prefix with 'v' for vanilla.
*/

// Get URL query parameters
function getQueryParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
}

// Takes a function 'fn'
// Executes 'fn' once the DOM has loaded (but before all assets finish loading)
function documentReady(fn: EventListener) {
    if (document.addEventListener) {
        document.addEventListener("DOMContentLoaded", fn);
    }
}

// Takes an element 'elem'
// Return true if an element is visisble and false if it is not
// function isVisible(elem) {
//     return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
// }
// Takes an element 'elem' and return bool if the element is visible or not
function isVisible(elem: HTMLElement) {
    if (elem == null) {
        return null;
    } else {
        return !(
            elem.classList.contains("visuallyhidden") ||
            elem.style.display == "none" ||
            getComputedStyle(elem).display == "none" ||
            elem.offsetWidth == 0 ||
            elem.offsetHeight == 0 ||
            elem.getClientRects().length == 0
        );
    }
}

// Takes an element 'elem' and an optional selector 'parentSelector'
// Returns an array of parent elements of 'elem', up to either document root or 'parentSelector' if it is provided
function getParents(elem: HTMLElement, parentSelector: HTMLElement) {
    if (parentSelector === undefined) {
        parentSelector = document.body;
    }
    var parents: Array<ParentNode> = [];
    let p = elem.parentNode;
    while (p !== parentSelector && p !== null) {
        const o: ParentNode = p;
        parents.push(o);
        p = o.parentNode;
    }
    parents.push(parentSelector);
    return parents;
}

// Takes an element 'el' and string 'tag'
// Returns an element that is a parent of 'el' and has the tagName property matching 'tag' or null if no such parent is found
// Please be aware that in javascript, the tagname property is often formatted as all uppercase, so matching div means tag should = DIV
function getParentElementWithTag(el: HTMLElement, tag: string) {
    if (el.parentElement !== null) {
        let currentElement: HTMLElement = el;
        while (
            currentElement.tagName !== tag.toUpperCase() &&
            currentElement.parentElement !== null
        ) {
            const objectPlaceholder: HTMLElement = currentElement;
            currentElement = objectPlaceholder.parentElement;
        }
        if (currentElement.tagName !== tag.toUpperCase()) {
            currentElement = null;
        }
        return currentElement;
    } else {
        return null;
    }
}

// Takes an element 'el'
// Returns an element that is either 'el' or a parent of 'el' and has the passed class, or null if nothing is found
function getParentElementWithClass(elem: HTMLElement, className: string) {
    if (elem !== null) {
        let currentElement: HTMLElement = elem;
        while (
            !currentElement.classList.contains(className) &&
            currentElement.parentElement !== null
        ) {
            const objectPlaceholder: HTMLElement = currentElement;
            currentElement = objectPlaceholder.parentElement;
        }
        if (!currentElement.classList.contains(className)) {
            currentElement = null;
        }
        return currentElement;
    } else {
        return null;
    }
}

// Takes an element 'el'
// Returns an true if one of the parents of 'el' has the class tablock or false if not
function isTablockChild(elem: HTMLElement) {
    if (elem.parentElement !== null) {
        let parent = elem.parentElement;
        while (
            !parent.classList.contains("tablock") &&
            parent.parentElement !== null
        ) {
            var parentObject = parent;
            parent = parentObject.parentElement;
        }
        return !parent.classList.contains("linkbox");
    } else {
        return false;
    }
}

// Takes an element 'elem'
// Returns true or false based on the presence of # in the href attribute of 'elem'
function isAnchorLink(elem: HTMLElement) {
    let isAnchor: boolean = false;
    if (
        elem.tagName === "A" &&
        elem.hasAttribute("href") &&
        elem.getAttribute("href").indexOf("#") > -1
    ) {
        isAnchor = true;
    }
    return isAnchor;
}

// Takes an element 'el'
// Returns true if the element's content is overflowing passed that element's boundaries in the DOM
function isOverflown(el: HTMLElement) {
    return el.scrollHeight > el.clientHeight + 15;
}

// Takes target element 'to', number 'duration', and optional function 'callbackFunction'
// Animates the windows to scroll down to 'to' at speed of 'duration'
// If 'callbackFunction' is defined, executes this function when the animation is complete
function vScrollTo(to: number, duration: number = 500, callbackFunction: Function = undefined) {
    const element: any = document.scrollingElement || document.documentElement;
    const start: number = element.scrollTop;
    const change: number = to - start;
    const startTs: number = performance.now();
    // t = current time
    // b = start value
    // c = change in value
    // d = duration
    function easeInOutQuad(t: number, b: number, c: number, d: number) {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
    }
    function animateScroll(ts: number) {
        const currentTime: number = ts - startTs;
        element.scrollTop = easeInOutQuad(currentTime, start, change, duration);
        if (currentTime < duration) {
            requestAnimationFrame(animateScroll);
        } else {
            element.scrollTop = to;
            if (callbackFunction !== undefined) {
                callbackFunction();
            }
        }
    }
    requestAnimationFrame(animateScroll);
}

// Takes element 'elem' and returns the top offset of 'elem'
function getOffsetTop(elem: HTMLElement) {
    const rect: DOMRect = elem.getBoundingClientRect();
    return (
        rect.top + window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0
    );
}

// Takes element 'elem' and returns the height, including padding and margins, of 'elem'
function vOuterHeight(elem: HTMLElement) {
    let height = elem.offsetHeight;
    const style = getComputedStyle(elem);
    height += parseInt(style.marginTop) + parseInt(style.marginBottom);
    return height;
}

// Takes element 'elem', optional number 'duration', and optional function 'callbackFunction'
// Slides 'elem' open at the speed of 'duration'
// If 'duration' is not provided, uses 500 as the default speed
// If 'callbackFunction' is defined, executes this function when the slide animation is complete
function vSlideUp(
    element: Element,
    duration: number = 500,
    callbackFunction: Function = undefined
) {
    const elem = element as HTMLElement;
    if (duration === undefined) {
        duration = 500;
    }
    elem.style.transitionProperty = "height, margin, padding";
    elem.style.transitionDuration = duration + "ms";
    elem.style.boxSizing = "border-box";
    elem.style.height = elem.offsetHeight + "px";
    elem.offsetHeight;
    elem.style.overflow = "hidden";
    elem.style.height = "0";
    elem.style.paddingTop = "0";
    elem.style.paddingBottom = "0";
    elem.style.marginTop = "0";
    elem.style.marginBottom = "0";
    window.setTimeout(function () {
        elem.style.display = "none";
        elem.style.removeProperty("height");
        elem.style.removeProperty("padding-top");
        elem.style.removeProperty("padding-bottom");
        elem.style.removeProperty("margin-top");
        elem.style.removeProperty("margin-bottom");
        elem.style.removeProperty("overflow");
        elem.style.removeProperty("transition-duration");
        elem.style.removeProperty("transition-property");
        if (callbackFunction !== undefined) {
            callbackFunction();
        }
    }, duration);
}

// Takes element 'elem', number 'duration', optional string 'display', and optional function 'callbackFunction'
// Slides 'elem' open at the speed of 'duration' if 'elem' display is set to "none"
// If 'duration' is not provided, uses 500 as the default speed
// Will set the CSS property "display" of 'elem' to 'display' or to "block" if 'display' is not set
// If 'callbackFunction' is defined, executes this function when the slide animation is complete
function vSlideDown(
    element: Element,
    duration: number = 500,
    display: string = "block",
    callbackFunction: Function = undefined
) {
    const elem = element as HTMLElement;
    if (duration === undefined) {
        duration = 500;
    }
    elem.style.removeProperty("display");
    var displayValue = window.getComputedStyle(elem).display;
    if (displayValue === "none" && display === undefined) {
        displayValue = "block";
    } else if (displayValue === "none") {
        displayValue = display;
    }
    elem.style.display = displayValue;
    var height = elem.offsetHeight;
    elem.style.overflow = "hidden";
    elem.style.height = "0";
    elem.style.paddingTop = "0";
    elem.style.paddingBottom = "0";
    elem.style.marginTop = "0";
    elem.style.marginBottom = "0";
    elem.offsetHeight;
    elem.style.boxSizing = "border-box";
    elem.style.transitionProperty = "height, margin, padding";
    elem.style.transitionDuration = duration + "ms";
    elem.style.height = height + "px";
    elem.style.removeProperty("padding-top");
    elem.style.removeProperty("padding-bottom");
    elem.style.removeProperty("margin-top");
    elem.style.removeProperty("margin-bottom");
    window.setTimeout(function () {
        elem.style.removeProperty("height");
        elem.style.removeProperty("overflow");
        elem.style.removeProperty("transition-duration");
        elem.style.removeProperty("transition-property");
        if (callbackFunction !== undefined) {
            callbackFunction();
        }
    }, duration);
}

// Takes an element 'elem' a number 'duration' and a string 'display'
// Slides 'elem' open at the speed of 'duration' if 'elem' display is set to "none"
// Slides 'elem' closed at the speed of 'duration' if 'elem' display is set to anything other than "none"
// If 'duration' is not provided, uses 500 as the default speed
// Optional attribute 'display' can be used to set what the CSS display property of 'elem' is set to when the vSlideDown animation is complete
function vSlideToggle(
    element,
    duration: number = 500,
    display: string = "block"
) {
    const elem = element as HTMLElement;
    if (duration === undefined) {
        duration = 500;
    }
    if (
        window.getComputedStyle(elem).display == "none" ||
        elem.style.display == "none"
    ) {
        return vSlideDown(elem, duration);
    } else {
        return vSlideUp(elem, duration);
    }
}

// Takes an element 'elem' and fades 'elem' out, and then sets the display CSS property of 'elem' to 'none' once the fade animaton is complete
function vFadeOut(elem: HTMLElement) {
    elem.style.opacity = "1";
    (function fade() {
        let val: number = parseFloat(elem.style.opacity);
        if ((val -= 0.1) < 0) {
            elem.style.display = "none";
        } else {
            elem.style.opacity = val.toString();
            requestAnimationFrame(fade);
        }
    })();
}

// Takes an element 'elem' and an optional string 'display' and fades 'elem' in, and then sets the display CSS property of 'elem' to 'display' once the fade animaton is complete
// Will set CSS display proerty to 'block' as a fallback if none is provided
function vFadeIn(elem: HTMLElement, display: string = "block") {
    elem.style.opacity = "0";
    elem.style.display = display || "block";
    (function fade() {
        let val: number = parseFloat(elem.style.opacity);
        if (!((val += 0.1) > 1)) {
            elem.style.opacity = val.toString();
            requestAnimationFrame(fade);
        }
    })();
}

// Takes an element 'elem' and an optional string 'display' and sets the display CSS property of 'elem' to 'display'
// Will set CSS display proerty to "block" as a fallback if none is provided
function vShow(elem: HTMLElement, display: string = "block") {
    elem.style.display = display || "block";
}

// Takes an element 'elem' and sets the display CSS property of 'elem' to "none"
function vHide(elem: HTMLElement) {
    elem.style.display = "none";
}

// Takes an element 'elem' and focuses the first selectable element within it
// Return null if no selectable element is found
function focusFirst(elem: HTMLElement) {
    if (elem !== null) {
        const selectableElements: NodeListOf<HTMLElement> =
            elem.querySelectorAll("a, input, textarea, button");
        for (let i = 0; i < selectableElements.length; i++) {
            if (isVisible(selectableElements[i])) {
                selectableElements[i].focus();
                return true;
            }
        }
    }
    return false;
}

// Takes an element 'elem' and focuses the last selectable element within it
// Return null if no selectable element is found
function focusLast(elem: HTMLElement) {
    if (elem !== null) {
        const selectableElements: NodeListOf<HTMLElement> =
            elem.querySelectorAll("a, input, textarea, button");
        for (let i = selectableElements.length - 1; i > -1; i--) {
            if (isVisible(selectableElements[i])) {
                selectableElements[i].focus();
                return true;
            }
        }
    }
    return false;
}

// Takes an element 'elem' and returns the first selectable and visible element within 'elem' or null if none is found
function getFirstSelectableElement(elem: HTMLElement) {
    if (elem !== null) {
        const selectableElements: NodeListOf<HTMLElement> =
            elem.querySelectorAll("button, a, input, select, textarea");
        if (selectableElements.length) {
            for (let i: number = 0; i < selectableElements.length; i++) {
                if (
                    selectableElements[i].tabIndex === 0 &&
                    isVisible(selectableElements[i])
                ) {
                    return selectableElements[i];
                }
            }
        }
    }
    return null;
}

// Takes an element as 'elem' returns the last selectable and visible element within 'elem' or null if none is found
function getLastSelectableElement(elem: HTMLElement) {
    if (elem !== null) {
        const selectableElements: NodeListOf<HTMLElement> =
            elem.querySelectorAll("button, a, input, select, textarea");
        if (selectableElements.length) {
            for (let i: number = selectableElements.length - 1; i > -1; i--) {
                if (
                    selectableElements[i].tabIndex === 0 &&
                    isVisible(selectableElements[i])
                ) {
                    return selectableElements[i];
                }
            }
        }
    }
    return null;
}

/********************************************************
 ** vExtend
 ********************************************************/
/*
    Extends properties of a function
*/
function vExtend(a, b) {
    for (var key in b) {
        if (b.hasOwnProperty(key)) {
            a[key] = b[key];
        }
    }
    return a;
}

/********************************************************
 ** Close Speedbump
 ********************************************************/
/*
    Reusable function to close / hide a speedbump on the site, also works for the confirm membership dialog
*/
function closeDialog(
    speedbumpElement: HTMLElement,
    clickedElement: HTMLElement,
    cancelFunction: Function
) {
    setTimeout(function () {
        speedbumpElement.classList.remove("dg-active");
    }, 100);
    setTimeout(function () {
        vHide(speedbumpElement);
    }, 600);
    speedbumpElement.removeAttribute("role");
    if (cancelFunction != undefined && cancelFunction !== null) {
        cancelFunction();
    }
    if (clickedElement != undefined && clickedElement !== null) {
        clickedElement.focus();
    }
    return false;
}

/********************************************************
 ** LINKBOX
 ********************************************************/
/*
    Makes an element's entire area a clickable link. Uses the href of the first link in the element as the link address
*/
// Event handler for linkbox links, including dynamic elements: Part 1, Click Events
document.addEventListener("click", function (event: MouseEvent) {
    const linkboxElement: HTMLElement = getParentElementWithClass(
        event.target as HTMLElement,
        "linkbox"
    );
    if (linkboxElement !== null) {
        const theLinkElement: HTMLElement = linkboxElement.querySelector("a");
        if (theLinkElement !== null) {
            if (linkboxElement != theLinkElement) {
                theLinkElement.click();
            }
        }
    }
});
// Part 2, Hover Events
document.onmouseover = function (event: MouseEvent) {
    const linkboxElement: HTMLElement = getParentElementWithClass(
        event.target as HTMLElement,
        "linkbox"
    );
    if (linkboxElement !== null) {
        linkboxElement.querySelector("a").classList.add("hovered");
    }
};
document.onmouseout = function (event: MouseEvent) {
    const linkboxElement: HTMLElement = getParentElementWithClass(
        event.target as HTMLElement,
        "linkbox"
    );
    if (linkboxElement !== null) {
        linkboxElement.querySelector("a").classList.remove("hovered");
    }
};

/********************************************************
 ** TABLOCK
 ********************************************************/
/*
    Prevents users from tabbing out of an area, such as a modal. Automatic based on the deepest container with class "tablock."
*/
document.addEventListener("keydown", function (event: KeyboardEvent) {
    const activeElement: any = document.activeElement;
    if (event.key === "Tab" && isTablockChild(activeElement)) {
        const shift: boolean = event.shiftKey;
        const tablockContainer: HTMLElement = getParentElementWithClass(
            activeElement,
            "tablock"
        );
        if (tablockContainer !== null) {
            const firstContainerElement: HTMLElement =
                getFirstSelectableElement(tablockContainer);
            const lastContainerElement: HTMLElement =
                getLastSelectableElement(tablockContainer);
            if (
                firstContainerElement !== null &&
                lastContainerElement !== null
            ) {
                if (firstContainerElement === activeElement && shift === true) {
                    event.preventDefault();
                    lastContainerElement.focus();
                    return false;
                } else if (
                    lastContainerElement === activeElement &&
                    shift === false
                ) {
                    event.preventDefault();
                    firstContainerElement.focus();
                    return false;
                }
            }
        }
    }
});

// Takes a string as 'cookieName', a string cookieValue, and an int 'numberOfDays' and creates a cookie by name name, with that value, and that lasts for that number of days
function setCookieValue(
    cookieName: string,
    cookieValue: string,
    numberOfDays: number
) {
    var expires: Date = new Date();
    expires.setDate(expires.getDate() + numberOfDays);
    document.cookie =
        cookieName +
        "=" +
        cookieValue +
        "; expires=" +
        expires.toUTCString() +
        ";";
}

// Takes a string as 'cookieName' returns the value of that cookie or an empty string if no cookie with that name is found
function getCookieValue(cookieName: string) {
    // Get name followed by anything except a semicolon
    const cookiestring: RegExpExecArray = RegExp(cookieName + "=[^;]+").exec(
        document.cookie
    );
    // Return everything after the equal sign, or an empty string if the cookie name not found
    return decodeURIComponent(
        !!cookiestring ? cookiestring.toString().replace(/^[^=]+./, "") : ""
    );
}

// Takes a string as 'cookieName' and sets that cookie to expire immediately. Usually this will take effect on refresh and not instantly.
function clearCookie(cookieName: string) {
    document.cookie =
        cookieName +
        "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; Max-Age=-99999999;";
}

/* Video Modal */
function getVideoID(videoURL: string) {
    let vid: string = null;
    if (videoURL.indexOf("vimeo") != -1) {
        vid = videoURL.replace("https://vimeo.com/", "").replace("https://player.vimeo.com/video/", "");
        if (vid.indexOf("/") != -1) {
            vid = vid.substring(0, vid.indexOf("/"));
        }
    } else if (videoURL.indexOf("youtube") != -1) {
        vid = videoURL.replace("https://www.youtube.com/watch?v=", "");
        if (vid.indexOf("/") != -1) {
            vid = vid.substring(0, vid.indexOf("/"));
        }
    } else if (videoURL.indexOf("youtu.be") != -1) {
        vid = videoURL.replace("https://youtu.be/", "");
        if (vid.indexOf("/") != -1) {
            vid = vid.substring(0, vid.indexOf("/"));
        }
    } else if (videoURL.indexOf(".mp4")) {
        const lastSlash = videoURL.lastIndexOf("/");
        vid = videoURL.substr(lastSlash + 1).replace(".mp4", "");
    }
    return vid.replace(/[^\w-=&]/gi, "");
}
function createShowVideoModal(
    videoURL: string,
    videoTitle: string = "Embedded Video",
    videoTranscript: string = 'Please <a href="' +
        CONTACTLINK +
        '">contact us</a> for a transcript of this video.'
) {
    if (null != videoURL && videoURL != "") {
        let videoID: string = getVideoID(videoURL);
        if (
            null != videoID &&
            null != document.getElementById("video_modal_" + videoID)
        ) {
            let videoModal = document.getElementById("video_modal_" + videoID);
            vShow(videoModal);
            focusFirst(videoModal);
            return true;
        } else if (null != videoID) {
            let videoCaption: string = "";
            let vidBuild: string =
                '<div class="video-flex-container"><div class="video-modal-content"><button class="video-modal-close js-video-modal-close" aria-lable="Close this video modal."><span class="button-symbol"></span></button>';
            if (videoURL.indexOf("vimeo") != -1) {
                vidBuild +=
                    '<div class="video-holder"><iframe src="https://player.vimeo.com/video/' +
                    videoID +
                    '?title=0&byline=0&portrait=0" alt="' +
                    videoTitle +
                    '" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>';
                vidBuild +=
                    '<div class="transcript-container js-accordion-container"><button class="transcript-button js-accordion-button" type="button" aria-expanded="false">Video Transcript</button><div class="transcript-content js-accordion-content"><p>This video uses Vimeo\'s native closed captioning features to provide a transcript. If closed captioning is unavailable for this video, please <a href="/contact/">contact us</a> and we can provide you with one.</p></div></div>';
            } else if (
                videoURL.indexOf("youtube") != -1 ||
                videoURL.indexOf("youtu.be") != -1
            ) {
                vidBuild +=
                    '<div class="video-holder"><iframe src="https://www.youtube.com/embed/' +
                    videoID +
                    '" alt="' +
                    videoTitle +
                    '" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="accelerometer; autoplay; encrypted - media; gyroscope; picture -in -picture; fullscreen" allowfullscreen></iframe></div>';
                vidBuild +=
                    '<div class="transcript-container js-accordion-container"><button class="transcript-button js-accordion-button" type="button" aria-expanded="false">Video Transcript</button><div class="transcript-content js-accordion-content"><p>This video uses YouTube\'s native closed captioning features to provide a transcript. If closed captioning is unavailable for this video, please <a href="/contact/">contact us</a> and we can provide you with one.</p></div></div>';
            } else if (videoURL.indexOf(".mp4")) {
                vidBuild +=
                    '<video class="local-video" controls autoplay><source src="' +
                    videoURL +
                    '" type="video/mp4"></video>';

                vidBuild +=
                    '<div class="transcript-container js-accordion-container"><button class="transcript-button js-accordion-button" type="button" aria-expanded="false">Video Transcript</button><div class="transcript-content js-accordion-content"></div></div>';
            }
            vidBuild += "</div></div>";

            const vidModal: HTMLElement =
                document.querySelector(".video-modal");
            if (vidModal !== null) {
                vidModal.parentNode.removeChild(vidModal);
            }

            let videoContainerDiv: HTMLElement = document.createElement("div");
            videoContainerDiv.classList.add("video-modal");
            videoContainerDiv.classList.add("js-video-modal");
            videoContainerDiv.setAttribute("id", "video_modal_" + videoID);
            videoContainerDiv.innerHTML = vidBuild;
            document.body.appendChild(videoContainerDiv);
            // Setup the accordions that were just added dynamically

            // ESC key behavior
            if (!videoContainerDiv.classList.contains("esc-bound")) {
                videoContainerDiv.addEventListener("keyup", function (event) {
                    if (
                        event.keyCode === 27 &&
                        videoContainerDiv.style.display !== "none"
                    ) {
                        closeVideoModal(videoContainerDiv);
                    }
                });
                videoContainerDiv.classList.add("esc-bound");
            }
            focusFirst(videoContainerDiv);
        }
        return true;
    } else {
        return null;
    }
}
function closeVideoModal(videoModal = null) {
    if (null != videoModal) {
        videoModal.remove();
        let videoModalTriggerElement: HTMLElement = document.querySelector(
            ".js-video-modal-trigger-element"
        );
        if (null != videoModalTriggerElement) {
            videoModalTriggerElement.focus();
            videoModalTriggerElement.classList.remove(
                "js-video-modal-trigger-element"
            );
        }
    }
}
/* Click event to trigger video modal */
document.addEventListener("click", function (event: Event) {
    if (event.target instanceof Element) {
        if (
            null != event.target.getAttribute("data-video") &&
            event.target.getAttribute("data-video") != ""
        ) {
            event.preventDefault();
            let videoTitle = "Embedded Video";
            if (null != event.target.getAttribute("data-title")) {
                videoTitle = event.target.getAttribute("data-title");
            }
            let videoTranscript =
                'Please <a href="' +
                CONTACTLINK +
                '">contact us</a> for a transcript of this video.';
            if (null != event.target.querySelector(".js-transcript")) {
                videoTranscript =
                    event.target.querySelector(".js-transcript").innerHTML;
            }
            event.target.classList.add("js-video-modal-trigger-element");
            createShowVideoModal(
                event.target.getAttribute("data-video"),
                videoTitle,
                videoTranscript
            );
        }
    }
});
/* Click event to close video modal */
document.addEventListener("click", function (event: Event) {
    const videoModalCloseButton: HTMLElement = getParentElementWithClass(
        event.target as HTMLElement,
        "js-video-modal-close"
    );
    const target: HTMLElement = event.target as HTMLElement;
    if (target.classList.contains("video-flex-container")) {
        let videoModal: HTMLElement = getParentElementWithClass(
            target,
            "js-video-modal"
        );
        closeVideoModal(videoModal);
    }
    if (null != videoModalCloseButton) {
        let videoModal: HTMLElement = getParentElementWithClass(
            videoModalCloseButton,
            "js-video-modal"
        );
        closeVideoModal(videoModal);
    }
});

/*** SCROLL ANIMATIONS ***/
let scrollObserver = new IntersectionObserver(
    function (entries) {
        entries.forEach(function (entry: IntersectionObserverEntry) {
            if (entry.target.matches(".scroll")) {
                if (entry.isIntersecting) {
                    entry.target.classList.add("active");
                }
            }
        });
    },
    { threshold: 0.001 }
);

let scrolls = document.querySelectorAll(".scroll");

scrolls.forEach(function (item) {
    scrollObserver.observe(item);
});

function alignTableRows(tableElement: HTMLElement) {
    let tableHeaders = tableElement.querySelectorAll<HTMLElement>(
        ".table-container .headers > li"
    );
    tableHeaders.forEach((header) => {
        document.documentElement.style.setProperty(
            header.getAttribute("data-rownum"),
            "auto"
        );
        let rowCells = tableElement.querySelectorAll<HTMLElement>(
            "[data-rownum=" + header.getAttribute("data-rownum") + "]"
        );
        let maxHeight = 0;
        rowCells.forEach((cell) => {
            if (cell.offsetHeight > maxHeight) {
                maxHeight = cell.offsetHeight;
            }
        });
        document.documentElement.style.setProperty(
            header.getAttribute("data-rownum"),
            maxHeight + "px"
        );
    });
}

function getElementIndex(node:Element) {
    var index:number = 0;
    while ( (node = node.previousElementSibling) ) {
        index++;
    }
    return index;
}